import { render, staticRenderFns } from "./permissionSet.vue?vue&type=template&id=295d9870&scoped=true&"
import script from "./permissionSet.vue?vue&type=script&lang=js&"
export * from "./permissionSet.vue?vue&type=script&lang=js&"
import style0 from "./permissionSet.vue?vue&type=style&index=0&id=295d9870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295d9870",
  null
  
)

export default component.exports